import axios, { AxiosError } from 'axios'
import {
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials,
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials,
} from 'interceptors'
import {
  EXCEL_PATH,
  ISSUED_PATH,
  REJECTED_PATH,
  REPORT_PATH,
  SEND_BY_EMAIL_PATH,
  SEND_REJECT_REPORT_EMAIL_PATH,
  UPLOAD_PATH,
} from 'lib'

const instance = axios.create({
  baseURL: process.env.REACT_APP_DOCUMENTS_API_SERVICE_DOMAIN,
})
const instanceConfig = axios.create({
  baseURL: process.env.REACT_APP_CONFIGURATION_API_SERVICE_DOMAIN,
})

instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials
)

export const sendDocumentReportByEmailService = async (params: any) => {
  try {
    const result = await instance.post(REPORT_PATH + SEND_BY_EMAIL_PATH, params)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const sendDocumentReportSuppliers = async (params: any) => {
  try {
    const result = await instanceConfig.post('/supplier-report', {
      emails: params,
    })
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const sendTaxAnalysisReportByEmailService = async (formData: FormData) => {
  try {
    const result = await instance.post('/ar-ap-report', formData)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const sendRejectedReportByEmailService = async (params: any) => {
  try {
    const result = await instance.post(REJECTED_PATH + SEND_REJECT_REPORT_EMAIL_PATH, params)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const sendRetentionReportByEmailService = async (params: any) => {
  try {
    const result = await instance.post(REPORT_PATH + ISSUED_PATH, params)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const uploadExcelService = async (file: File, userId: number) => {
  const formData = new FormData()
  formData.append('file1', file)
  formData.append('userId', userId.toString())

  try {
    const response = (await instance.post(UPLOAD_PATH + EXCEL_PATH, formData)).data
    return response
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}
